import { makeRequest } from './data_utils';

// ================================
// Prompt Sets Operations
// ================================

const getPromptSets = () => {
    const endpoint = `api/prompts/sets`;
    return makeRequest(endpoint, 'GET');
};

const getPromptSet = (promptSetId) => {
    const endpoint = `api/prompts/sets/${promptSetId}`;
    return makeRequest(endpoint, 'GET');
};

const createPromptSet = (name, type) => {
    const endpoint = `api/prompts/sets`;
    const body = {
        name: name,
        type: type
    };
    return makeRequest(endpoint, 'POST', body);
};

const updatePromptSet = (promptSetId, name, type, active) => {
    const endpoint = `api/prompts/sets/${promptSetId}`;
    const body = {
        name: name,
        type: type,
        active: active
    };
    return makeRequest(endpoint, 'PUT', body);
};

const deletePromptSet = (promptSetId) => {
    const endpoint = `api/prompts/sets/${promptSetId}`;
    return makeRequest(endpoint, 'DELETE');
};

const getCompletePromptSet = (promptSetId) => {
    const endpoint = `api/prompts/sets/${promptSetId}/complete`;
    return makeRequest(endpoint, 'GET');
};

// ================================
// Prompt Scripts Operations
// ================================

const getPromptScripts = () => {
    const endpoint = `api/prompts/scripts`;
    return makeRequest(endpoint, 'GET');
};

const getPromptScript = (scriptId) => {
    const endpoint = `api/prompts/scripts/${scriptId}`;
    return makeRequest(endpoint, 'GET');
};

const createPromptScript = (name, description, script, system_script) => {
    const endpoint = `api/prompts/scripts`;
    const body = {
        name: name,
        description: description,
        script: script,
        system_script: system_script
    };
    return makeRequest(endpoint, 'POST', body);
};

const updatePromptScript = (scriptId, name, description, script, system_script, active) => {
    const endpoint = `api/prompts/scripts/${scriptId}`;
    const body = {
        name: name,
        description: description,
        script: script,
        system_script: system_script,
        active: active
    };
    return makeRequest(endpoint, 'PUT', body);
};

const deletePromptScript = (scriptId) => {
    const endpoint = `api/prompts/scripts/${scriptId}`;
    return makeRequest(endpoint, 'DELETE');
};

// ================================
// Prompt Set Sections Operations
// ================================

const getPromptSetSections = (promptSetId) => {
    const endpoint = `api/prompts/sets/${promptSetId}/sections`;
    return makeRequest(endpoint, 'GET');
};

const createPromptSetSection = (promptSetId, prompt_script_id, type, llm_model) => {
    const endpoint = `api/prompts/sets/${promptSetId}/sections`;
    const body = {
        prompt_script_id: prompt_script_id,
        type: type,
        llm_model: llm_model
    };
    return makeRequest(endpoint, 'POST', body);
};

const updatePromptSetSection = (promptSetId, sectionId, prompt_script_id, type, llm_model) => {
    const endpoint = `api/prompts/sets/${promptSetId}/sections/${sectionId}`;
    const body = {
        prompt_script_id: prompt_script_id,
        type: type,
        llm_model: llm_model
    };
    return makeRequest(endpoint, 'PUT', body);
};

const deletePromptSetSection = (promptSetId, sectionId) => {
    const endpoint = `api/prompts/sets/${promptSetId}/sections/${sectionId}`;
    return makeRequest(endpoint, 'DELETE');
};

// ================================
// Prompt Set Sections Validation
// ================================

const getPromptSetValidation = (promptSetId) => {
    const endpoint = `api/prompts/sets/${promptSetId}/validate`;
    return makeRequest(endpoint, 'POST');
};

// ================================
// Prompt Cloning
// ================================

const clonePromptScript = (scriptId, name, description) => {
    const endpoint = `api/prompts/scripts/${scriptId}/clone`;
    const body = {
        name: name,
        description: description
    };
    return makeRequest(endpoint, 'POST', body);
};

const clonePromptSet = (promptSetId, name, type) => {
    const endpoint = `api/prompts/sets/${promptSetId}/clone`;
    const body = {
        name: name,
        type: type
    };
    return makeRequest(endpoint, 'POST', body);
};

// ================================
// Prompt LLM Models
// ================================

const getLLMModels = (type) => {
    let endpoint = `api/prompts/models`;
    if (type === 'active'){
        endpoint = `api/prompts/models/active`;
    }
    return makeRequest(endpoint, 'GET');
};

export const promptData = {
    // Prompt Sets
    getPromptSets,
    getPromptSet,
    createPromptSet,
    updatePromptSet,
    deletePromptSet,
    getCompletePromptSet,
    
    // Prompt Scripts
    getPromptScripts,
    getPromptScript,
    createPromptScript,
    updatePromptScript,
    deletePromptScript,
    
    // Prompt Set Sections
    getPromptSetSections,
    createPromptSetSection,
    updatePromptSetSection,
    deletePromptSetSection,

    // Prompt Set Validation
    getPromptSetValidation,

    // Prompt Cloning
    clonePromptScript,
    clonePromptSet,

    // Prompt LLM Models
    getLLMModels
}; 